import { Injectable, TemplateRef } from '@angular/core';
import { PatientDataService } from '.';
import { SecureBaseComponentContext } from '../modules/tcm-common/services/secure-base-component-context.service';
import { ScreenSourceEnum } from '../common/screen-source-enum';
import { NavigationService } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(private patientDataService: PatientDataService, private navService: NavigationService ) {
  }

  public async validatePatientInfoAsync(patientId: number, insuranceId: number, source: ScreenSourceEnum, appointmentTypeId: number, cancellationToken: Promise<any> = null) {
    const validationResult = await this.patientDataService.validatePatientInfoAsync(patientId, null, insuranceId, appointmentTypeId, cancellationToken);
    if (!validationResult.isValid) {
      
      const request = {
        messages: validationResult.messages,
        patientId: patientId,
        responsiblePartMessages: validationResult.responsiblePartMessages,
        responsiblePartId: validationResult.responsiblePartId,
        insuranceId: validationResult.insuranceId,
        appointmentTypeId: appointmentTypeId,
        source: source
      };
      
      this.navService.navigateWithModal(
        '/patients/details/patient-validation',
        'sm',
        request);

      return false;
    }

    return true;
  }

  public async validatePatientInfoByClinicAsync(patientId: number, clinicId: number, insuranceId: number, source: ScreenSourceEnum, cancellationToken: Promise<any> = null) {
    const validationResult = await this.patientDataService.validatePatientInfoAsync(patientId, clinicId, insuranceId, null, cancellationToken);
    if (!validationResult.isValid) {

      const request = {
        messages: validationResult.messages,
        patientId: patientId,
        responsiblePartMessages: validationResult.responsiblePartMessages,
        responsiblePartId: validationResult.responsiblePartId,
        insuranceId: validationResult.insuranceId,
        source: source
      };

      this.navService.navigateWithModal(
        '/patients/details/patient-validation',
        'sm',
        request);

      return false;
    }

    return true;
  }


  public async validatePatientInfoBySalesOrderAsync(salesOrderId: number, source: ScreenSourceEnum, cancellationToken: Promise<any> = null) {
    const validationResult = await this.patientDataService.validatePatientInfoBySalesOrderAsync(salesOrderId, cancellationToken);
    const model = {
      messages: validationResult.messages,
      patientId: validationResult.patientId,
      responsiblePartMessages: validationResult.responsiblePartMessages,
      responsiblePartId: validationResult.responsiblePartId,
      insuranceId: validationResult.insuranceId,
      source: source,
      isValid: true
    };
    if (!validationResult.isValid) {
         
      model.isValid = false;
      this.navService.navigateWithModal(
        '/patients/details/patient-validation',
        'sm',
        model);

      return model;
    }

    return model;
  }


  public async validatePatientInfoByAppointmentAsync(appoinmentId: number, source: ScreenSourceEnum, cancellationToken: Promise<any> = null) {
    const validationResult = await this.patientDataService.validatePatientInfoByAppointmentAsync(appoinmentId, cancellationToken);
    if (!validationResult.isValid) {

      const request = {
        messages: validationResult.messages,
        patientId: validationResult.patientId,
        responsiblePartMessages: validationResult.responsiblePartMessages,
        responsiblePartId: validationResult.responsiblePartId,
        insuranceId: validationResult.insuranceId,
        source: source
      };

      await this.navService.navigateWithModal(
        '/patients/details/patient-validation',
        'sm',
        request);

      return false;
    }

    return true;
  }


}
